import { Icon } from "./Icon.tsx";

/** "Add Junction" tool icon — a node dot with a plus badge. */
export function AddJunctionIcon() {
  return (
    <Icon>
      <circle cx="10" cy="14" r="5" />
      <path d="M18 3v6M15 6h6" />
    </Icon>
  );
}
